import React, { useCallback, Fragment, useState } from "react";
import { ScreenSpaceEventType, Cartographic, Math } from "cesium";
import { ScreenSpaceEventHandler, ScreenSpaceEvent, useCesium } from "resium";
import { useTranslation } from "react-i18next";
import styles from "./index.module.less";

function MouseCoordinatePanel() {
  const { t } = useTranslation();
  const context = useCesium();
  const [longitude, setLongitude] = useState();
  const [latitude, setLatitude] = useState();
  const display = useCallback(
    (e) => {
      const { scene, camera } = context;
      const cartesian = camera.pickEllipsoid(
        e.endPosition,
        scene.globe.ellipsoid
      );
      if (cartesian) {
        const cartographic = Cartographic.fromCartesian(cartesian);
        const longitudeString = Math.toDegrees(cartographic.longitude).toFixed(
          4
        );
        const latitudeString = Math.toDegrees(cartographic.latitude).toFixed(4);
        setLongitude(longitudeString);
        setLatitude(latitudeString);
      }
    },
    [context]
  );
  return (
    <Fragment>
      <ScreenSpaceEventHandler>
        <ScreenSpaceEvent
          action={(e) => display(e)}
          type={ScreenSpaceEventType.MOUSE_MOVE}
        />
      </ScreenSpaceEventHandler>
      <div className={styles.mouseCoordinatePanel}>
        <div className="longitude-container">
          {t("longitude")}: {longitude}
        </div>
        <div className="latitude-container">
          {t("latitude")}: {latitude}
        </div>
      </div>
    </Fragment>
  );
}

export default MouseCoordinatePanel;
